import { NavigationMenuLink } from "@radix-ui/react-navigation-menu";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

import { type CallDisplayMode, useCallContext } from "./CallContext";

export function CallModeMenu() {
  const { activeMode, setActiveMode } = useCallContext();

  return (
    <CallModeMenuUI activeMode={activeMode} setActiveMode={setActiveMode} />
  );
}

export interface CallModeMenuUIProps {
  activeMode: CallDisplayMode;
  setActiveMode: React.Dispatch<React.SetStateAction<CallDisplayMode>>;
}

export const CallModeMenuUI = ({
  activeMode,
  setActiveMode,
}: Readonly<CallModeMenuUIProps>) => {
  return (
    <NavigationMenu
      value={activeMode}
      onValueChange={(value) => {
        if (["ai", "transcript", "script", "debug", "report"].includes(value)) {
          setActiveMode(value as CallDisplayMode);
        }
      }}
    >
      <NavigationMenuList>
        <NavigationMenuItem value="script">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "script" ? "border border-gray-300 font-bold" : ""
            }`}
            onClick={() => {
              setActiveMode("script");
            }}
          >
            Call
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem value="ai">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "ai" ? "border border-gray-300 font-bold" : ""
            }`}
            onClick={() => {
              setActiveMode("ai");
            }}
          >
            AI
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem value="transcript">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "transcript"
                ? "border border-gray-300 font-bold"
                : ""
            }`}
            onClick={() => {
              setActiveMode("transcript");
            }}
          >
            Transcript
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem value="report">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${
              activeMode === "report" ? "border border-gray-300 font-bold" : ""
            }`}
            onClick={() => {
              setActiveMode("report");
            }}
          >
            Report
          </NavigationMenuLink>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};
